export const Roles = {
  bronze: 'Bronze',
  bartender: 'Bartender',
  owner: 'Owner',
  admin: 'Admin'
};
